















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { dateFormat } from '@/helpers/dateFormat';
import ArrayUtils from '@/helpers/arrayUtils';

        // @click:clear="handleClear()"
        //         :picker-date="pickerDates()"
        // :formatDate="formatDate"
            // @change="onChangeDates()"
@Component
export default class UiDatePickerMultiple extends Vue {
  @Prop({
    default: '',
  })
  public label!: string;
  @Prop()
  public value!: any[];
  @Prop({
    default: null,
  })
  public min?: string;
  @Prop({
    default: null,
  })
  public max?: string;
  @Prop({
    default: null,
  })
  public allowedDates?: string;
  @Prop({
    default: '',
  })
  public suffix?: string;
  @Prop({
    default: '',
  })
  public placeholder?: string;
  @Prop({
    default: '',
  })
  public height?: string;
  @Prop({
    default: false,
  })
  public singleLine?: boolean;
  @Prop({
    default: false,
  })
  public outline?: boolean;
  @Prop({
    default: false,
  })
  public hideDetails?: boolean;
  @Prop({
    default: false,
  })
  public required?: boolean;
  @Prop({
    default: () => [],
  })
  public rules?: any[];
  @Prop({
    default: false,
  })
  public clearable?: boolean;
  @Prop({
    default: false,
  })
  public disabled?: boolean;

  private dateMenu: boolean = false;

  private dateFormatted: any = null;
  private date: any = null;

  private dates: any = [];
  private datesPicker: any = [];

  // private pickerDate: any = null;


  @Watch('value')
  public onChangeValue(val: any[]): void {       
    this.date = val;
    this.dates = [];
    this.refreshValue(val);
  }

  public onChange(): void {
    this.$emit('input', this.datesPicker);
    this.$emit('change', this.datesPicker);
  }

  private formatDate(date: string): string {
    return !date ? '' : dateFormat(date, 'BR', undefined, true);
  }

  @Watch('datesPicker')
  public onChangeDates(datasUS: any[]): void {
    const datasFormatadas = [];
    datasUS.forEach( function (item, indice, array) {
      datasFormatadas.push(dateFormat(item, 'BR', undefined, true));
   });
    this.dates = datasFormatadas;
    this.onChange();
  }

  // @Watch('pickerDate')
  // public pickerDates(val: any): void {

  // }
  private refreshValue(listaDatas: any[]){
    const datesAux = [];
    const datesPickerAux = [];
    listaDatas.forEach( function (item, indice, array) {
        datesAux.push(dateFormat(item, 'BR', undefined, true));
        datesPickerAux.push(item);
    });
    this.dates = datesAux.sort();    
    if (!ArrayUtils.equalsIgnoreOrder(listaDatas, this.datesPicker)) {
      this.datesPicker = datesPickerAux;    
    }
  }


  @Watch('dateMenu')
  public dateMenuStatus(val: any): void {
    if(!val){
      //this.onChange();
    }
  }

  public allowedDatesF(d){    
    if (!this.allowedDates || !this.allowedDates.length) {
      return true;
    }
    return this.allowedDates.indexOf(d) != -1;
  }

}
